// import { isClient } from './utils/isClient'
// It possible to create 2 different services (for Node and Client) if needed

import { injectable } from 'inversify'
// @ts-ignore
import PureCache from 'pure-cache'
import { CacheService } from './cacheService'

const defaultCacheExpiryIn = 1000 * 60 * 30
let cacheStore = new PureCache({ expiryCheckInterval: defaultCacheExpiryIn })

@injectable()
export class PureCacheService implements CacheService {
  set(key: string, val: unknown, time?: number): void {
    cacheStore.put(key, val, time || defaultCacheExpiryIn)
  }
  get(key: string): unknown {
    const res = cacheStore.get(key)
    return res && res.value
  }
  remove(key: string): void {
    cacheStore.remove(key)
  }
  clearAll(): void {
    // clears all cached keys
    cacheStore.dispose()
    cacheStore = new PureCache({ expiryCheckInterval: defaultCacheExpiryIn })
  }
}
//  DON'T DELETE - used by DW
